import { render } from "./model-header.vue?vue&type=template&id=dedda734"
import script from "./model-header.vue?vue&type=script&lang=js"
export * from "./model-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__